import {
  UNLOCK_CONTENT_TEMPORARILY,
  CLEAR_TEMPORARILY_UNLOCKED_CONTENT,
} from '../../actions/channelBlocker/constants';

const initialState = {
  id: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UNLOCK_CONTENT_TEMPORARILY: {
      return {
        id: action.payload,
      };
    }
    case CLEAR_TEMPORARILY_UNLOCKED_CONTENT: {
      return {
        id: null,
      };
    }
    default:
      return state;
  }
};
